import React, { useEffect, useState } from 'react';
import TotalCountCard from './total-count-card';
import { useDispatch } from 'react-redux';

import axios from 'axios';
import { ENDPOINTS } from '../../js/api/_config';

import { Link, useLocation, useNavigate } from 'react-router';
import { Navigate } from 'react-router-dom';
import FunnelChart from '../common/chart/funnelChart';
import LineChart from '../common/chart/lineChart';
import LineChartV2 from '../common/chart/lineChartV2';
import ChartHeader from '../common/chart/chartHeader';
import { funnelChartColors } from '../../js/api/constants';
import PieChart from '../common/chart/pieChart';
import BarChart from '../common/chart/barChart';

const TotalCount = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate();

  const refreshPage = () => {
    navigate(0); // Pass the current path for navigation
  };
  const goToLogin = () => {
    navigate("/login");
  };
  const [dataValue, setData] = useState({
    totalPatients: 0,
    totalTrials: 0,
    totalClinics: 0,
    totalRecruiters: 0,
    totalCalls: 0,
    answeredCalls: 0,
    bookedCalls: 0
  });

  const [funnelData, setFunnelData] = useState([]);
  const [studyData, setStudyData] = useState([]);
  const [studyVolData, setStudyVolData] = useState([]);
  const [studyOutcomeData, setStudyOutcomeData] = useState([]);

  const [funnelChartLoading, setFunnelChartLoading] = useState(true);
  const [studyChartLoading, setStudyChartLoading] = useState(true);
  const [barChartLoading, setBarChartLoading] = useState(true);
  const [pieChartLoading, setPieChartLoading] = useState(true);


  async function fetchDashboardData() {
    setLoading(true)
    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.GET_COUNT);
      setData(response.data.data); // Set the data from the API response
      setLoading(false)
    } catch (error) {

      console.error('Error fetching dashboard data:', error);
    }
  }

  const funnelChartData = async (filters) => {
    setFunnelChartLoading(true);
    const params = {};

    if (filters.filterType) {
      params.filterType = filters.filterType;
    }
    if (filters.fromDate) {
      params.fromDate = filters.fromDate;
    }
    if (filters.toDate) {
      params.toDate = filters.toDate;
    }
    if (filters.trialID) {
      params.trialID = filters.trialID;
    }
    if (filters.clinicalInfoID) {
      params.clinicalInfoID = filters.clinicalInfoID;
    }

    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.FUNNEL_ANALYTICS, {
        params: params,
      });
      if (response.data && response.data.data.length > 0) {

        let data = response.data.data.map(item => {
          return {
            stage: item.statusName,
            count: item.count,
            width: `${item.percentage}`,
            color: funnelChartColors[item.statusName] || "#4B5563CC"
          }
        });

        let totalCount = response.data.data.reduce((sum, item) => sum + item.count, 0);

        data.unshift({
          stage: "Total",
          count: totalCount,
          width: "100",
          color: "#4B5563CC"
        });

        setFunnelData(data);
      } else {
        setFunnelData([]);
      }



    } catch (error) {

      console.error('Error fetching dashboard data:', error);
    }
    finally {
      setFunnelChartLoading(false);
    }
  }

  const studyChartData = async (filters) => {
    setStudyChartLoading(true);
    const params = {};

    if (filters.filterType) {
      params.filterType = filters.filterType;
    }
    if (filters.fromDate) {
      params.fromDate = filters.fromDate;
    }
    if (filters.toDate) {
      params.toDate = filters.toDate;
    }
    if (filters.trialID) {
      params.trialID = filters.trialID;
    }
    if (filters.clinicalInfoID) {
      params.clinicalInfoID = filters.clinicalInfoID;
    }

    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.STUDY_ANALYTICS, {
        params: filters,
      });

      if (response.data && response.data.data.length > 0) {
        const new_data = response.data.data.map(item => {
          return {
            name: item.trialName,
            percentage: item.patientPercentage,
            attributes: item.patientDetailsList,
            attributesCount: item.patientCount,
            data: item // Assuming dataPoints is an array of { date, value
          }
        });

        setStudyData(new_data);
      } else {
        setStudyData([]);
      }

    } catch (error) {

      console.error('Error fetching dashboard data:', error);
    }
    finally {
      setStudyChartLoading(false);
    }
  }

  const barChartData = async (filters) => {
    setBarChartLoading(true);
    const params = {};

    if (filters.filterType) {
      params.filterType = filters.filterType;
    }
    if (filters.fromDate) {
      params.fromDate = filters.fromDate;
    }
    if (filters.toDate) {
      params.toDate = filters.toDate;
    }
    if (filters.trialID) {
      params.trialID = filters.trialID;
    }
    if (filters.clinicalInfoID) {
      params.clinicalInfoID = filters.clinicalInfoID;
    }

    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.CALL_VOLUME_BY_STUDY, {
        params: filters,
      });

      if (response.data && response.data.data.length > 0) {
        const new_data = response.data.data.map(item => {
          return {
            label: item.day,
            hoverLable1: "Total",
            hoverLable2: "Answered",
            value1: item.totalCalls,
            value2: item.answeredCalls,
            color1: "#4179B1",
            color2: "#94C453"
          }
        });
        setStudyVolData(new_data);
        console.log("Bar Chart Data", new_data);
      } else {
        setStudyVolData([]);
      }

    } catch (error) {

      console.error('Error fetching dashboard data:', error);
    }
    finally {
      setBarChartLoading(false);
    }
  }

  const pieChartData = async (filters) => {
    setPieChartLoading(true);
    const params = {};

    if (filters.filterType) {
      params.filterType = filters.filterType;
    }
    if (filters.fromDate) {
      params.fromDate = filters.fromDate;
    }
    if (filters.toDate) {
      params.toDate = filters.toDate;
    }
    if (filters.trialID) {
      params.trialID = filters.trialID;
    }
    if (filters.clinicalInfoID) {
      params.clinicalInfoID = filters.clinicalInfoID;
    }

    try {
      const response = await axios.get(ENDPOINTS.DASHBOARD.CALL_OUTCOME_BY_STUDY, {
        params: filters,
      });


      if (response.data && response.data.data) {
        setStudyOutcomeData([
          { label: "Answered", value: response.data.data?.answeredCalls || 0, color: "#94C453" },
          { label: "Missed", value: response.data.data?.missed || 0, color: "#D74F4F" },
          { label: "Voicemail", value: response.data.data?.voicemail || 0, color: "#5D60E7" }
          // { label: "Rejected", value: response.data.data?.Rejected || 0, color: "#F27451" }
        ]);
      } else {
        setStudyOutcomeData([]);
      }

    } catch (error) {

      console.error('Error fetching dashboard data:', error);
    }
    finally {
      setPieChartLoading(false);
    }
  }



  useEffect(() => {
    fetchDashboardData();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 p-4 pt-5">
        <Link to="/locations"><TotalCountCard title="Locations" bgColor="bg-[#EFF1FF]" count={dataValue.totalClinics} loading={loading} /></Link>
        <Link to="/trials">
          <TotalCountCard 
            title="Trials"
            count={dataValue.totalTrials}
            icondivBgColor="bg-[#ECDEFF]"
            bgColor="bg-[#F5EEFF]"
            borderColor="border-[#C8D6E6]"
            iconBgColor="bg-[#AE78FB]"
            iconColor="text-[#ECDEFF]"
            loading={loading}
          />
        </Link>
        <Link to="/patients">
          <TotalCountCard
            title="Patients"
            count={dataValue.totalPatients}
            icondivBgColor="bg-[#FDECD2]"
            bgColor="bg-[#FEF6EA]"
            borderColor="border-[#C8D6E6]"
            iconBgColor="bg-[#FBBD61]"
            iconColor="bg-[#FBBD61]"
            loading={loading}
          />
        </Link>
        <Link to="/recruiters">
          <TotalCountCard
            title="Recruiters"
            count={dataValue.totalRecruiters}
            icondivBgColor="bg-[#FFDAD1]"
            bgColor="bg-[#FFF2EF]"
            borderColor="border-[#C8D6E6]"
            iconBgColor="bg-[#EE8062]"
            iconColor="text-yellow-600"
            loading={loading}
          />
        </Link>
      </div>

      <div className='grid gap-5 p-4 pt-5'>

        <div className='p-4 px-6 rounded-lg border border-blue-100 '>
          <div>
            <span className='font-semibold'>Voice Agent Call Summary</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 pt-5">
            <TotalCountCard
              title="Total Calls"
              count={dataValue.totalCalls}
              icondivBgColor="bg-[#C7DDF4]"
              bgColor="bg-[#E7F3FF]"
              borderColor="border-[#C8D6E6]"
              iconBgColor="bg-[#4179B1]"
              iconColor="text-[#ECDEFF]"
              loading={loading}
            />

            <TotalCountCard
              title="Answered Calls"
              count={dataValue.answeredCalls}
              icondivBgColor="bg-[#E4F0D4]"
              bgColor="bg-[#F1FFE6]"
              borderColor="border-[#C8D6E6]"
              iconBgColor="bg-[#94C453]"
              iconColor="bg-[#FBBD61]"
              loading={loading}
            />

            <TotalCountCard
              title="Booked From Calls"
              count={dataValue.bookedCalls}
              icondivBgColor="bg-[#C9EDD0]"
              bgColor="bg-[#EAF8ED]"
              borderColor="border-[#C8D6E6]"
              iconBgColor="bg-[#6CD07F]"
              iconColor="text-yellow-600"
              loading={loading}
            />
          </div>
        </div>
      </div>

      <div className='p-4 pt-0'>
        <div className='flex justify-between items-center mb-4 gap-4'>

          <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[460px]">
            <ChartHeader title={'Patient Funnel Analytics'}
              onChange={(val) => {
                const values = {
                  filterType: 'custom',
                  fromDate: val.dateRange.startDate,
                  toDate: val.dateRange.endDate,
                  clinicalInfoID: val.selectedLocations.length > 0 ? val.selectedLocations.join(",") : null,
                  trialID: val.selectedStudies.length > 0 ? val.selectedStudies.join(",") : null
                };
                funnelChartData(values);
              }}
            />
            <FunnelChart isLoading={funnelChartLoading} data={funnelData || []} />
          </div>

          <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[460px]">
            <ChartHeader title={'Action Required by Study'}
              onChange={(val) => {
                const values = {
                  filterType: 'custom',
                  fromDate: val.dateRange.startDate,
                  toDate: val.dateRange.endDate,
                  clinicalInfoID: val.selectedLocations.length > 0 ? val.selectedLocations.join(",") : null,
                  trialID: val.selectedStudies.length > 0 ? val.selectedStudies.join(",") : null
                };
                studyChartData(values)
              }}
            />
            <LineChartV2 isLoading={studyChartLoading} label="Patients" data={studyData}
              onAttrClick={(val) => {
                navigate(`/conversation-patients/${val.patientTrialJuncID}`, { replace: true });
              }}
              onTitleClick={(item) => {
                navigate(`/trial-statuses/action_required?trial_id=${item.data.trialID}&&status=Action Required&&sorting=desc&&trial_name=${item.data.trialName}`)
              }}
            />
          </div>


        </div>
        <div className='flex justify-between items-center mb-4 gap-4'>

          <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[460px]">
            <ChartHeader title={'Call Volume'}
              onChange={(val) => {
                const values = {
                  filterType: 'custom',
                  fromDate: val.dateRange.startDate,
                  toDate: val.dateRange.endDate,
                  clinicalInfoID: val.selectedLocations.length > 0 ? val.selectedLocations.join(",") : null,
                  trialID: val.selectedStudies.length > 0 ? val.selectedStudies.join(",") : null
                };
                barChartData(values)
              }}
            />
            <BarChart
              isLoading={barChartLoading}
              data={studyVolData}
              height={300} />
          </div>

          <div className="flex-1  rounded-lg border border-blue-100 font-mont p-4 px-6 h-[460px]">
            <ChartHeader title={'Call Outcomes Distribution'}
              onChange={(val) => {
                const values = {
                  filterType: 'custom',
                  fromDate: val.dateRange.startDate,
                  toDate: val.dateRange.endDate,
                  clinicalInfoID: val.selectedLocations.length > 0 ? val.selectedLocations.join(",") : null,
                  trialID: val.selectedStudies.length > 0 ? val.selectedStudies.join(",") : null
                };
                pieChartData(values)
              }}
            />
            <PieChart
              isLoading={pieChartLoading}
              data={studyOutcomeData}
              size={250}
            />
          </div>

        </div>
        {/* <div className='flex justify-between items-center mb-4 gap-4'>
          <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[400px]">
            <ChartHeader title={'Action Required by Study'} onChange={(val) => {
              console.log('Funnel Chart Filters changed', val)
            }}
            />
            <LineChartV2 data={studyData} />
          </div>

          <div className="flex-1 rounded-lg border border-blue-100 font-mont p-4 px-6 h-[400px]">
          
          </div>


        </div> */}
      </div>
    </>
  );
};

export default TotalCount;
